var _rect, _line, _line2, _line3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBurgerMenuBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 61,
    viewBox: "0 0 63 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.927734,
    width: 61.9917,
    height: 60.6585,
    fill: "#B3D237"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 19.209,
    y1: 18.7407,
    x2: 46.6339,
    y2: 18.7407,
    stroke: "black",
    strokeWidth: 0.914163
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 19.209,
    y1: 28.7963,
    x2: 36.5781,
    y2: 28.7963,
    stroke: "black",
    strokeWidth: 0.914163
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 19.209,
    y1: 38.8525,
    x2: 46.6339,
    y2: 38.8525,
    stroke: "black",
    strokeWidth: 0.914163
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurgerMenuBtn);
export default __webpack_public_path__ + "static/media/burger-menu-btn.6757526465d0409cf70e0d98254ba0a7.svg";
export { ForwardRef as ReactComponent };